import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { workwiseServices } from "../Services/workWiseServices";
import Loader from "../Comp/SkeletonLoader/skeletonLoader";
import { getWorkWiseAuthToken } from "../Utils/helper";
import { setDocumentInformation, setUserInformation } from "../Reducers/documentInfoSlice";
import { message } from "antd";

export const AuthenticateDocument = ({ setIsLoading }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleAuthenticate = async () => {
    setIsLoading(true);
  
    if (!navigator.onLine) {
      return navigate("/no-internet");
    }
  
    try {
      const token = getWorkWiseAuthToken();
      if (!token) {
        return navigate("/unauthorized");
      }
  
      const { status, data } = await workwiseServices.getDocumentById(id);
      const documentData = data?.data;
  
      if (status === 200) {
        if (documentData?.rightType === 0) {
          return navigate("/unauthorized");
        }
        dispatch(setDocumentInformation(documentData));
      } 
    } catch (error) {
      const { status, data: { responseCode } = {} } = error.response || {};
      if (status === 401) {
        navigate("/unauthorized");
      } else if (responseCode === 1008) {
        navigate("/invalid-document");
      } else {
        message.error('Something went wrong while processing.');
      }
    } finally {
      setIsLoading(false);
    }
  };
  

  useEffect(() => {
    handleAuthenticate();
    const token = getWorkWiseAuthToken();
    if (token) {
      try {
        const info = JSON.parse(atob(token.split(".")[1]));
        dispatch(setUserInformation(info));
      } catch (error) {
        console.error("Failed to parse token", error);
      }
    }
  }, []);

  return <Loader />;
};
